import axios from "axios";
import {downloadFile} from "../../utils/file/download";

export class AladdinService {

    getTodayUdiValue(){

        return axios.get('/appapv/getTodayUdiValue.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res =>  res.data);
    }

    saveUdiValue(udiValue, udiDate){

        return axios.put('/appapv/saveUdi.action', {}, {
         params: {
            udiValue: udiValue,
             udiDate: udiDate
         },
            headers: {
                'Content-Type': 'application/json',
            }
         }).then(res =>  res.data);
    }

    getUdiValuesCSV(){
       return downloadFile('/appapv/getSavedUdiFile.action');
    }

}